import { Component, OnInit, EventEmitter, Output } from '@angular/core';

@Component({
  selector: 'app-create-task',
  templateUrl: './create-task.component.html',
  styleUrls: ['./create-task.component.scss']
})
export class CreateTaskComponent implements OnInit {

  createClose:boolean = false;
  SubTask:boolean = false;
  
  attach3c = false;
  
  @Output() closeCreateTask = new EventEmitter<boolean>()

  constructor() { }

  ngOnInit(): void {
  }

  closeCreate(message:boolean){
    this.closeCreateTask.emit(message)
  }

  showSubTask(){
    this.SubTask = !this.SubTask
  }

  
  colors = [
    {
     colname:'#F5D428'     
   },
   {
     colname:'#6FC040'
   },
   {
     colname:'#52A7F9'
    },
    {
      colname:'#EF8F1E'
    },
    {
     colname:'#EC5C58'
    },
    {
      colname:'#B36AE2'
    },
 ]

 selectedColor:any = '#db241c';
 showColorPannel = false;

  myFunction(browser) {
    this.selectedColor = browser;
  }

  toggleColorSelection(){
    this.showColorPannel = !this.showColorPannel
  }

}
